import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from "@angular/router";
import { BillsService } from "../../../injections/bills.service";

@Component({
    moduleId: module.id,
    selector: 'main-bills-gyh',
    templateUrl: '../templates/main-bill-gyh.html',
    providers: [],
})

export class MainBillGYHComponent implements OnInit {

    public showModal = false;
    public paidBill = false;
    public html = '';
    public showModalBill = false;
    public showModalDownload = false;
    public payment;
    public id;
    public bill;
    constructor(private route: ActivatedRoute, private billService: BillsService) {
        this.route.params.subscribe(params => {
          this.id = params["id"];
        });

     }

    public displayModal(event){
       if(event["action"] == "close"){
         this.showModal = false;
         if(event["data"] != null){
             this.setPaymentBill(event["data"]);
         }
       }else {
           this.payment = event["data"];
           this.showModal = true;
       }
    }

     public displayModalBill(event) {
        if(event["action"] == "close"){
         this.showModalBill = false;
         if(event["data"] != null){
            
         }
       }else {
           this.showModalBill = true;
           this.getInvoiceHTML(event["data"]);
       }
    }

    public displayModalDownload(event) {
        if(event["action"] == "close"){
         if(event["data"] != null){
             this.downloadBill(event["data"]);
         }else{
            this.showModalDownload = false;
         }
       }else {
        this.showModalDownload = true;
       }
    }

    public setPaymentBill(pay: number) {

        this.billService.setBillPayment(this.id,pay.toString()).subscribe(status => {
            if(status == "OK"){
                this.bill["payed"] = pay;
            }
        });
    }

    public downloadBill(number: string){
        this.billService.downloadBillGYH(this.bill["cleanerId"].toString(),this.bill["date_period"],number).subscribe( result => {
            var fileURL = URL.createObjectURL(result);
            var link = document.createElement('a');
            link.href = fileURL;
            link.download = this.bill["cleanerName"].replace(/ /g, "").replace(",","") +'_'+ this.bill["date_period"] + '_' + number +'.pdf';
            link.click();
            this.showModalDownload = false;
        });
    }

    public getInvoiceHTML(data: any){
        this.billService.getInvoiceHTMLGYH(data["cleanerId"], data["date_period"]).subscribe(res => {
            this.html = res;
            this.showModalBill = true;
        });
    }
 
    ngOnInit() {
        this.billService.getCleanerBillDetail(this.id).subscribe(result => {
            this.bill = result;
            this.bill["id"] = this.id;
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/modules/bills/components/main-bill-gyh.component.ts